/*** IMPORTS FROM imports-loader ***/
(function() {

/* eslint-disable no-unused-vars */

class ListUser {
  constructor(user) {
    this.id = user.id;
    this.name = user.name;
    this.username = user.username;
    this.avatar = user.avatar_url;
  }
}

window.ListUser = ListUser;

}.call(window));


// WEBPACK FOOTER //
// ./boards/models/user.js.es6